import { render, staticRenderFns } from "./ForgotPasswordFire.vue?vue&type=template&id=f77f0f3e"
import script from "./ForgotPasswordFire.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordFire.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordFire.vue?vue&type=style&index=0&id=f77f0f3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports